import React from 'react';

import { addIcon, coachesIcon, courtsIcon, inviteIcon, playersIcon, writeIcon } from '../../../../utils/icons';

import styles from './Footer.module.scss';

type Props = {
    variant?: string,
    buttons?: ({ title: string, icon: string, onClick: () => void } | null)[]
};

export default function Footer({ variant, buttons }: Props) {
    return (
        <div className={styles.footer}>
            <div className={styles.footerGradient}/>

            {buttons
                ? buttons.map((button, i) => (
                    <div key={button?.title || i} className={styles.footerItem} onClick={button?.onClick}>
                        {button && (
                            <>
                                <div className="icon" style={{ backgroundImage: `url(${button.icon})` }}/>
                                <span className="icon-text">{button.title}</span>
                            </>
                        )}
                    </div>
                ))
                : (
                    <>
                        <div className={styles.footerItem}>
                            {(variant === 'search') && (
                                <>
                                    <div className="icon" style={{ backgroundImage: `url(${playersIcon})` }}/>
                                    <span className="icon-text">Players</span>
                                </>
                            )}
                            {(variant === 'players' || variant === 'courts') && (
                                <>
                                    <div className="icon" style={{ backgroundImage: `url(${writeIcon})` }}/>
                                    <span className="icon-text">Write</span>
                                </>
                            )}
                        </div>

                        <div className={styles.footerItem}>
                            {(variant === 'search') && (
                                <>
                                    <div className="icon" style={{ backgroundImage: `url(${coachesIcon})` }}/>
                                    <span className="icon-text">Coaches</span>
                                </>
                            )}
                            {(variant === 'players' || variant === 'courts') && (
                                <>
                                    <div className="icon" style={{ backgroundImage: `url(${addIcon})` }}/>
                                    <span className="icon-text">Add</span>
                                </>
                            )}
                        </div>

                        <div className={styles.footerItem}>
                            {(variant === 'search') && (
                                <>
                                    <div className="icon" style={{ backgroundImage: `url(${courtsIcon})` }}/>
                                    <span className="icon-text">Courts</span>
                                </>
                            )}
                            {(variant === 'players' || variant === 'courts') && (
                                <>
                                    <div className="icon" style={{ backgroundImage: `url(${inviteIcon})` }}/>
                                    <span className="icon-text">Invite</span>
                                </>
                            )}
                        </div>
                    </>
                )}
        </div>
    );
}
